import { differenceInCalendarDays } from "date-fns";
import { DateTime } from "luxon";

import { PerkStatus, getPerkStatusLabel } from "../../types";

export const hackerAPIDateToDueDate = (value: string | null) => {
  if (value === null) return "";

  const date = DateTime.fromISO(value);
  const isInFiveDays = date <= DateTime.now().plus({ days: 5 });
  if (isInFiveDays) {
    return date.toRelativeCalendar();
  }

  // Only show month and day (e.g., "May 21")
  return date.toLocaleString({ month: "short", day: "numeric" });
};

export const isInFiveDays = (value: string | null) => {
  if (value === null) return false;

  const date = DateTime.fromISO(value);
  return date <= DateTime.now().plus({ days: 5 });
};

export const getDaysUntilDueDate = (value: string | null): number | null => {
  if (!value) return null;
  return differenceInCalendarDays(new Date(value), new Date());
};

type LabelColor = "success" | "warning" | "danger" | undefined;

export const getDueColor = (daysUntilDue: number | null): LabelColor => {
  if (typeof daysUntilDue !== "number") return undefined;
  if (daysUntilDue > 10) return "success";
  if (daysUntilDue >= 5) return "warning";
  return "danger";
};

export const getDueDateBadge = (value: string | null): string => {
  const label = hackerAPIDateToDueDate(value);
  return value ? `Due ${label}` : "";
};

export const perkStatusToBadgeColor = (
  status: PerkStatus | null | undefined
) => {
  switch (status ?? PerkStatus.NOT_STARTED) {
    case PerkStatus.NOT_STARTED:
    case PerkStatus.INCOMPLETE:
      return "secondary";
    case PerkStatus.SUBMITTED:
      return "primary";
    case PerkStatus.APPROVED:
    case PerkStatus.COMPLETED:
      return "success";
    default:
      return "secondary";
  }
};

export { getPerkStatusLabel };

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);
